<div class="row mt-3">
    <div class="form-check form-switch">
        <input class="form-check-input" id="acceptCVG-checkbox" name="acceptCVG-checkbox" type="checkbox"
               [formControl]="acceptCGV">
        <label class="form-check-label" for="acceptCVG-checkbox" translate="common.terms.acceptCVG">
            <a href="#/cgv" target="_blank">{{ 'common.cgvFull' | translate }}</a></label>
    </div>
    <app-form-error [control]="acceptCGV"></app-form-error>
</div>
